import React, {Fragment, SyntheticEvent, useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import {FormLabel} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import AddIcon from "@mui/icons-material/Add";
import charcreate from "../../_helper/charcreate";
import {rollerOpen, rollerSetRoll} from "../../_helper/rollBehave";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_skills} from "../../_signals/s_char";
import {ICharSkill} from "../../_interfaces/ICharSkill";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {SkillsCreate, SkillsDelete, SkillsUpdate} from "../../_api/BESkills";
import updChar from "../../_sig_api/updChar";
import {styled} from "@mui/material/styles";
import {InfoTalentSkillSubscriber} from "../../_helper/InfoTalentSkillBehave";
import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import SkillsEdit from "./SkillsEdit";
import EditIcon from "@mui/icons-material/Edit";
import getSkillDefines from "./getSkillDefines";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

interface IProps {
    roll:boolean
}
function Skills({roll}:IProps) {
    useSignals()

    const [ccFree, setCCFree] = useState(0)
    const [edit, setEdit] = useState('')

    const fix = ['Lesen/Schreiben', 'Kunsthandwerk', 'Fremdsprachen']

    const mod_rank = [...Array(7).keys()];

    useEffect(() => {
        if (!s_char.value.cc_skills) calcUsedFree()
    }, [])

    const handleInfoPopOpen = (skillname: string, e: SyntheticEvent) => {
        const skill = TalentSkillSubscriber.value.find(s => s.hasOwnProperty('lps_skill') && s.name === skillname)
        if (skill) {
            InfoTalentSkillSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: skill})
        }
    }

    const calcUsedFree = () => {
        const usedFree = s_char_skills.value.reduce((s, skill) => {
            if (skill.name === 'Lesen/Schreiben') return s + (skill.stepfree === 1 ? 0 : skill.stepfree - 1)
            if (skill.name === 'Kunsthandwerk') return s + (skill.stepfree === 1 ? 0 : skill.stepfree - 1)
            if (skill.name === 'Fremdsprachen') return s + (skill.stepfree === 2 ? 0 : skill.stepfree - 2)
            return s + skill.stepfree
        }, 0);
        console.log('usedFree', usedFree);

        setCCFree(charcreate.fertigkeiten - usedFree);

    }

    const ccSkills = () => {

        let skills: ICharSkill[] = [
            {
                id: v4(),
                cid: s_char.value.id,
                name: 'Kunsthandwerk',
                lpstart: 100,
                step: 1,
                stepfree: 1,
                strain: 0,
                attribute: 'cha',
                karma: false,
                define: [],
                define_single: ['Backen', 'Bildende Kunst', 'Bildhauerei', 'Geschichtenerzählen', 'Handwerk', 'Jonglieren', 'Karten Zeichnen', 'Kleidung und Stil', 'Kochen', 'Korbflechten', 'Körpermalerei', 'Musizieren', 'Poesie', 'Runenschnitzen', 'Rüstung Herstellen', 'Schauspielern', 'Schnitzen', 'Singen', 'Sticken', 'Tanzen', 'Tätowieren', 'Unterhalten', 'Waffe Herstellen']
            },
            {
                id: v4(),
                cid: s_char.value.id,
                name: 'Fremdsprachen',
                lpstart: 100,
                step: 2,
                stepfree: 2,
                strain: 0,
                attribute: 'wah',
                karma: false,
                define: ['Zwergisch'],
                define_multi: ['Menschlich', 'Obsidianisch', 'Or’zet', 'Sperethiel', 'Trollisch', 'T’skrang', 'Windling', 'Zwergisch']
            },
            {
                id: v4(),
                cid: s_char.value.id,
                name: 'Lesen/Schreiben',
                lpstart: 100,
                step: 1,
                stepfree: 1,
                strain: 0,
                attribute: 'wah',
                karma: false,
                define: ['Zwergisch'],
                define_multi: ['Menschlich', 'Obsidianisch', 'Or’zet', 'Sperethiel', 'Trollisch', 'T’skrang', 'Windling', 'Zwergisch']
            }]
        skills.forEach(s => SkillsCreate(s))
        s_char_skills.value = skills
    }

    const getSkills = () => {
        let skills: ICharSkill[] = [];

        for (let j = 0; j < TalentSkillSubscriber.value.length; j++) {
            if (fix.includes(TalentSkillSubscriber.value[j].name)) continue
            if (TalentSkillSubscriber.value[j].hasOwnProperty('lps_skill')) {
                let data_talente_skill = TalentSkillSubscriber.value[j];
                const skill: ICharSkill = {
                    id: v4(),
                    cid: s_char.value.id,
                    name: data_talente_skill.name,
                    lpstart: data_talente_skill.lps_skill ?? 0,
                    step: 0,
                    stepfree: 0,
                    strain: data_talente_skill.strain,
                    attribute: data_talente_skill.attribute,
                    karma: false,
                    define: [],
                    define_single: data_talente_skill.hasOwnProperty('define_single') ? data_talente_skill.define_single : [],
                    define_multi: data_talente_skill.hasOwnProperty('define_multi') ? data_talente_skill.define_multi : []
                }
                skills.push(skill);
            }
        }

        skills.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

        return skills;
    }

    const skillRow = (skill: ICharSkill) => {

        skill = getSkillDefines(skill)

        return <TableRow key={skill.id}>
            <TableCell width={'100%'}>
                <Stack direction={'row'} justifyContent="space-between" alignItems="baseline">
                    {(!skill.name || ccFree > 0) && !fix.includes(skill.name) ? <FormControl style={{width: '100%'}}>
                            <Select key={skill.id}
                                    value={skill.name}
                                    onChange={(e) => editName(skill.id, e)}>
                                {getSkills().map(a => <MenuItem key={v4()} value={a.name}>{a.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                        :
                        <Fragment>
                            <div>
                                <div style={{fontWeight: 'bolder'}}>{skill.name}</div>
                                {!roll && skill.define.length > 0 ? <div>{skill.define.sort().join(', ')}</div> : null}
                                {!roll && skill.hasOwnProperty('define_multi') && skill.define_multi!.length > 0 && skill.define!.length !== skill.step ?
                                    <div style={{fontStyle:'italic',color:'red'}}>freie Zuweisungen vorhanden</div>
                                    :
                                    null
                                }
                                {!roll && skill.hasOwnProperty('define_single') && skill.define_single!.length > 0 && skill.define!.length == 0 ?
                                    <div style={{fontStyle:'italic',color:'red'}}>freie Zuweisung vorhanden</div>
                                    :
                                    null
                                }

                            </div>
                            <HelpOutlineSharpIcon fontSize={'small'}
                                                  onClick={(e) => handleInfoPopOpen(skill.name, e)}/>
                        </Fragment>
                    }
                </Stack>
            </TableCell>
            {!roll && <TableCell>
                {ccFree === 0 ? <Stack spacing={2} direction="row">
                    <Stack spacing={2} direction="row">
                            <span>Stufe&nbsp;{skill.step}</span>
                            <Button className={'btn'} size="small" onClick={() => setEdit(skill.id)}>
                                <EditIcon/>
                            </Button>
                        </Stack>
                    </Stack> :
                    <Stack spacing={2} direction="row">
                        <FormLabel>Frei</FormLabel>
                        <Select key={v4()}
                                value={skill.stepfree || '0'}
                                onChange={(e) => changeSkillFreeSteps(skill.id, e)}
                                name={'freesteps'}
                        >
                            {mod_rank.map(r => {
                                if (skill.name === 'Lesen/Schreiben' && r < 1) return <MenuItem disabled={true}
                                                                                                key={v4()}
                                                                                                value={r}>{r}</MenuItem>
                                if (skill.name === 'Kunsthandwerk' && r < 1) return <MenuItem disabled={true} key={v4()}
                                                                                              value={r}>{r}</MenuItem>
                                if (skill.name === 'Fremdsprachen' && r < 2) return <MenuItem disabled={true} key={v4()}
                                                                                              value={r}>{r}</MenuItem>
                                return <MenuItem key={v4()} value={r}>{r}</MenuItem>
                            })
                            }
                        </Select>
                    </Stack>}
            </TableCell>}
            <TableCell>
                {ccFree > 0 || skill.step === 0 ?
                    !(skill.name === 'Lesen/Schreiben' || skill.name === 'Kunsthandwerk' || skill.name === 'Fremdsprachen') ?
                        <Button className={'btn'} onClick={() => removeSkill(skill.id)}>-</Button>
                        :
                        null

                    :
                    <Button className={'btn'} size="small" onClick={() => setRoll(skill)}>
                        <CasinoOutlinedIcon/>
                    </Button>
                }
            </TableCell>
        </TableRow>
    }

    const setRoll = (skill: ICharSkill) => {
        const roll: IRollerRoll = {
            attribute: skill.attribute,
            canusekarma: false,
            karma: false,
            step_mod: 0, // step_mod
            step: skill.step,
            strain: skill.strain,
            title: skill.name,
            target: [],
            targetVS: '',
            vs: 0,
            as: '',
            as_fix: false
        };
        rollerSetRoll(roll, true, false);
        rollerOpen();
    }

    const changeSkillFreeSteps = (skillid: string, event: any) => {
        const {value} = event.target;

        let skills = s_char_skills.value

        skills = skills.map(t => {
            if (t.id === skillid) {
                t.step = value;
                t.stepfree = value;
                SkillsUpdate(t)
            }
            return t;
        });

        s_char_skills.value = skills
        calcUsedFree()
    }

    const editName = (skillid: string, event: any) => {
        event.preventDefault();
        const {value} = event.target;

        let skills = s_char_skills.value

        const available = getSkills();

        skills = skills.map((skill) => {
            if (skill.id === skillid) {

                for (let i = 0; i < available.length; i++) {
                    if (available[i].name === value) {
                        skill.lpstart = available[i].lpstart;
                        if (available[i].hasOwnProperty('strain_skill')) {
                            skill.strain = available[i].strain_skill ?? 0;
                        } else {
                            skill.strain = available[i].strain;
                        }
                        skill['attribute'] = available[i].attribute;

                        if (available[i].hasOwnProperty('define_multi')) {
                            skill.define_multi = available[i].define_multi;
                            skill.define = [];
                        }
                        if (available[i].hasOwnProperty('define_single')) {
                            skill.define_single = available[i].define_single;
                            skill.define = [];
                        }
                    }
                }
                skill.name = value;
                SkillsUpdate(skill)

            }
            return skill;
        });

        s_char_skills.value = skills

    }

    const addSkill = () => {

        const skill: ICharSkill = {
            id: v4(),
            cid: s_char.value.id,
            name: '',
            attribute: '',
            lpstart: 0,
            step: 0,
            stepfree: 0,
            strain: 0,
            karma: false,
            define: []
        }
        s_char_skills.value = [...s_char_skills.value, skill];
        SkillsCreate(skill)
    }

    const removeSkill = (id) => {

        let skills = s_char_skills.value

        skills = skills.filter(t => {
            if (t.id !== id) return true;
            else {
                calcUsedFree();
                SkillsDelete(t)
                return false;
            }
        });

        s_char_skills.value = skills;

    }

    const cc_done_skills = () => {
        updChar([{k: 'cc_skills', v: true}])
        let char = s_char.value
        char.cc_skills = true;
        s_char.value = char
    }

    return <Fragment>
        <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
            <h3 style={{margin: "5px"}}>Fertigkeiten <AddIcon onClick={() => addSkill()}/>
                {s_char_skills.value.length === 0 && ccFree === charcreate.fertigkeiten ?
                    <Button className={'btn'} onClick={() => ccSkills()}>Anfangsfertigkeiten</Button> : null
                }
                {!s_char.value.cc_skills ? <Item>
                <span style={{color: ccFree < 0 ? 'red' : 'black'}}>
                {'verbleibende Punkte: ' + ccFree}
                </span>
                    {ccFree === 0 ? <Button onClick={cc_done_skills}>abschliessen</Button> : null}
                </Item> : null}
            </h3>
            <Paper>
            </Paper>

            <Paper key={v4()} style={{padding: 4}}>
                <TableContainer style={{maxHeight: 450}}>
                    <Table stickyHeader style={{width: '100%'}} size="small">
                        <TableBody>
                            {s_char_skills.value.map((skill) => skillRow(skill))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

        </Paper>
        <SkillsEdit edit={edit} isOpen={setEdit}/>
    </Fragment>
}

export default Skills;
